// Components==============
import SearchBar from 'components/UI/SearchBar';
import React from 'react';
// =========================

export default function Filter({ searchValue, setSearchValue }) {
    return (
        <SearchBar
            searchValue={searchValue}
            setSearchValue={setSearchValue}
        />
    );
}
